import { gsap } from 'gsap/dist/gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

export default class FinesseGrid extends HTMLElement {
  gridItems: NodeList | null =  null

  constructor() {
    super()

    gsap.registerPlugin(ScrollTrigger)

    // add scoll trigger options to every grid item
    this.gridItems = this.querySelectorAll('div[data-grid-item]')

    const timeline = gsap.timeline({})

    if (this.gridItems) {
      gsap.to("[data-speed]", {
        y: (_, el) => (1 - parseFloat(el.getAttribute("data-speed"))) * ScrollTrigger.maxScroll(window) ,
        ease: "none",
        scrollTrigger: {
          start: 0,
          end: "max",
          invalidateOnRefresh: true,
          scrub: 0
        }
      });
      Array.from(this.gridItems).map(gridItem => {
        timeline.to(gridItem,
          {
            y: (_, el) => {
              const speed = parseFloat(el.getAttribute('data-speed'))
              const mobileSpeed = speed > 1 ? (speed * 0.95) : (speed < 1 ? (speed * 1.05) : speed)
              const adjustedSpeed = window.innerWidth < 769 ? mobileSpeed : speed

              return (1 - adjustedSpeed) * ScrollTrigger.maxScroll(window)
            },
            ease: 'none',
            scrollTrigger: {
              start: 0,
              end: 'max',
              invalidateOnRefresh: true,
              scrub: 1,
            }
        })
      })
    }
  }
}

customElements.define('finesse-grid', FinesseGrid)
